export default __webpack_public_path__ + "static/4-bb8197673478aa6ea1ee41981a58d48c.jpg";